import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { Button, Card, Col, Form, Input, Row, Typography} from "antd";

import LeftImage from "../../assets/images/leftside_login.jpg"
import OLBLogo from "../../assets/images/olb_logo.png"
import './styles.scss'

const { Title } = Typography;

const Login = ({ userStore }) => {

    const [form] = Form.useForm();

    const onFinish = (values) => {
        userStore.login(values)
    }

    return (
        <div className="login">
            <div className="main-body">
                <div className="upper-body">
                    {/* <img className="logo" src={OLBLogo}/> */}
                    <div className="introduction">
                        <Title level={4}>SIGN IN 🚀</Title>
                    </div>
                    
                </div>
                <div className="lower-body">
                    
                    {/* <div className="left">
                        <img className="leftside_login" src={LeftImage}/>
                    </div> */}
                    <Card>
                    <p>Welcome Back! Log in to access your account and manage everything in one place.</p>
                        <div className="mt-5"/>
                        <Form 
                            name="loginform"
                            layout="vertical"
                            form={form} 
                            onFinish={onFinish}
                        >
                            <Form.Item
                                label="Username"
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your username.',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your password.',
                                    },
                                ]}
                            >
                                <Input type="password" />
                            </Form.Item>
                            <div className="mt-5"/>
                            <Button type="primary" htmlType="submit" size="large" loading={userStore.loading} block>LOGIN</Button>
                        </Form>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default inject('userStore')(observer(Login));
